import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { getTransactionTypeConfig } from './transactionTypeConfig';

interface TransactionTypeBadgeProps {
  type: string;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

const TransactionTypeBadge: React.FC<TransactionTypeBadgeProps> = ({
  type,
  size = 'small',
  variant = 'filled'
}) => {
  const config = getTransactionTypeConfig(type);

  if (!config) {
    return <Chip label={type} size={size} sx={{ fontWeight: 500 }} />;
  }

  const isSmall = size === 'small';

  return (
    <Tooltip title={config.description} arrow>
      <Chip
        label={config.label}
        size={isSmall ? 'small' : 'medium'}
        sx={{
          height: isSmall ? '24px' : '32px',
          fontSize: isSmall ? '0.7rem' : '0.8rem',
          fontWeight: 500,
          backgroundColor: config.backgroundColor,
          color: config.color,
          border: `1px solid ${config.color}`,
          cursor: 'help',
          transition: 'all 0.2s ease',
          '&:hover': {
            boxShadow: `0 2px 8px ${config.color}40`,
            transform: 'translateY(-1px)'
          }
        }}
        variant={variant}
      />
    </Tooltip>
  );
};

export default TransactionTypeBadge;
